import { Context } from '../..';
import * as base from '../base';

const CONTROLLER = 'contexts';

enum AIContextType {
  FreeText = 'FreeText',
  WebSearch = 'WebSearch',
  File = 'File',
}

export interface ContextDto {
  id: string;
  dateCreated: string;
  type: AIContextType;
  label: string;
  text: string;
}

export interface ContextListDto {
  id: string;
  dateCreated: string;
  type: AIContextType;
  label: string;
}

export interface UpsertFreeTextContextRequest {
  label: string;
  text: string;
  id?: string;
}

interface UpsertWebSearchContextRequest {
  label: string;
  searchTerm: string;
  id?: string;
}

export async function getContextById(context: Context, payload: string): Promise<ContextDto | undefined> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, payload) };
  const response: base.IResponse<ContextDto> = await base.requestWithRetries(request);
  return response.data;
}

export async function getContextsByCompany({state}: Context): Promise<ContextListDto[] | undefined> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, `company`, state.companyVariables.slug!) };
  const response: base.IResponse<ContextListDto[]> = await base.requestWithRetries(request);
  return response.data;
}

export async function upsertFreeTextContext({ state }: Context, payload: UpsertFreeTextContextRequest): Promise<string | undefined> {
  const request: base.IRequest = {
    url: base.aiURL(CONTROLLER, `freetext`, state.companyVariables.slug!),
    method: 'PUT',
    body: JSON.stringify(payload),
  };
  const response: base.IResponse<string> = await base.requestWithRetries(request);
  return response.data;
}

export async function upsertWebSearchContext({ state }: Context, payload: UpsertWebSearchContextRequest): Promise<string | undefined> {
  const request: base.IRequest = {
    url: base.aiURL(CONTROLLER, `websearch`, state.companyVariables.slug!),
    method: 'PUT',
    body: JSON.stringify(payload),
  };
  const response: base.IResponse<string> = await base.requestWithRetries(request);
  return response.data;
}

export async function upsertFileContext({ state }: Context, payload: { searchParams: { label: string; id?: string }; file?: File }): Promise<string | undefined> {
  const body = new FormData();

  // Add form fields exactly as the API expects them
  if (!!payload.file) {
    body.append('file', payload.file);
  }

  const request: base.IRequest = {
    url: base.aiURL(CONTROLLER, `file`, `${state.companyVariables.slug}${base.params(payload.searchParams)}`),
    method: 'PUT',
    body,
    headers: {}, // Don't set Content-Type header - browser will set it with boundary
  };
  const response: base.IResponse<string> = await base.requestWithRetries(request);
  
  return response.data;
}

export async function deleteContext(context: Context, payload: string): Promise<void> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, payload), method: 'DELETE' };
  await base.requestWithRetries(request);
}
